import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// export const rootApi = createApi({
//     reducerPath: 'apiTushar',
//     tagTypes: [],
//     baseQuery: fetchBaseQuery({
//         baseUrl: 'http://localhost:5000/api/admin',
//     }),
//     endpoints: (builder) => ({}),
// });

const prepareHeaders = (headers) => {
    headers.set('ngrok-skip-browser-warning', 'any-value');
    return headers;
};

export const rootApi = createApi({
    reducerPath: "apiTushar",
    tagTypes: [],
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}`,
        prepareHeaders,
    }),
    endpoints: (builder) => ({}),
});

export const rootApiSupplyBeam = createApi({
    reducerPath: "apiTusharSupplyBeam",
    tagTypes: [],
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_SUPPLY_BEAM_BASE_URL}`,
        // baseUrl: 'http://localhost:6001/api/supply-beam',
        // baseUrl: `https://supply-api-dev.genefied.in/api/supply-beam`,
        prepareHeaders,
    }),

    endpoints: (builder) => ({}),
});
